import React, { useEffect, useState } from 'react';
import Navbar from "../../components/Features/Navbar";
import hr from "./../../images/icons/hr.png";
import { Box, CircularProgress, Container, Grid, useMediaQuery, useTheme } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from '../../components/Home/Footer';
import { Fade } from 'react-awesome-reveal';
import LogoExpertCo from './../../images/logos/LogoExpertConnection.png';
import LogoInfoCo from './../../images/logos/LogoInfoConnection.png';
import LogoSportConnection from './../../images/logos/LogoSportConnection.png';
import StrapiRichText from '../../components/StrapiRichText';
import { NOS_ACTIONS_DEFAULTS } from '../../content/nosActionsFallbacks';
import { fetchNosActionsFromStrapi } from '../../services/strapiNosActions';
import { pickCmsText, pickCmsTitle } from '../../utils/cmsContent';

const blockListSx = {
  fontSize: '18px',
  marginTop: '1rem',
  '& ul': { listStyleType: 'circle', marginLeft: '1.5rem', paddingLeft: '0.25rem' },
  '& li': { marginBottom: '0.35rem' },
};

const partnersListSx = {
  fontSize: '18px',
  marginTop: '1rem',
  '& ul': { listStyleType: 'disc', marginLeft: '1.25rem', paddingLeft: '0.25rem' },
  '& li': { marginBottom: '0.75rem' },
};

const NosActions = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (content?.title) {
      document.title = `${content.title} | Tsahal Connection`;
    } else {
      document.title = 'Nos Actions | Tsahal Connection';
    }
  }, [content?.title]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const remote = await fetchNosActionsFromStrapi();
        if (cancelled) return;
        const d = NOS_ACTIONS_DEFAULTS;
        setContent({
          title: pickCmsTitle(remote?.title, d.title),
          blockInfoConnection: pickCmsText(remote?.blockInfoConnection, d.blockInfoConnection),
          blockExpertConnection: pickCmsText(remote?.blockExpertConnection, d.blockExpertConnection),
          blockSportConnection: pickCmsText(remote?.blockSportConnection, d.blockSportConnection),
          partnersTitle: pickCmsTitle(remote?.partnersTitle, d.partnersTitle),
          partnersBody: pickCmsText(remote?.partnersBody, d.partnersBody),
        });
      } catch {
        if (!cancelled) {
          const d = NOS_ACTIONS_DEFAULTS;
          setContent({
            title: d.title,
            blockInfoConnection: d.blockInfoConnection,
            blockExpertConnection: d.blockExpertConnection,
            blockSportConnection: d.blockSportConnection,
            partnersTitle: d.partnersTitle,
            partnersBody: d.partnersBody,
          });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading || !content) {
    return (
      <div>
        <Navbar />
        <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: '40vh', alignItems: 'center' }}>
          <CircularProgress sx={{ color: '#1398aa' }} />
        </Box>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <Fade triggerOnce>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginTop: '2rem' }}>
          <h1 style={{ fontFamily: 'Montserrat', fontWeight: '700', textAlign: 'center' }}>{content.title}</h1>
          <img src={hr} alt="" width="80" height="50" />
        </div>
        <Container maxWidth="md" style={{ marginTop: '3rem', marginBottom: '4rem' }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12} sm={4} style={isSmallScreen ? { display: 'flex', justifyContent: 'center', marginBottom: '2rem' } : undefined}>
                  <img src={LogoInfoCo} alt="" style={{ width: '250px', height: '250px' }} />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <StrapiRichText source={content.blockInfoConnection} sx={blockListSx} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} style={{ marginTop: '4rem' }}>
              <Grid container>
                <Grid item xs={12} sm={8}>
                  <StrapiRichText source={content.blockExpertConnection} sx={blockListSx} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  style={
                    isSmallScreen
                      ? { order: -1, display: 'flex', justifyContent: 'center', marginBottom: '2rem' }
                      : { display: 'flex', justifyContent: 'flex-end' }
                  }
                >
                  <img src={LogoExpertCo} alt="" style={{ width: '250px', height: '250px' }} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} style={{ marginTop: '4rem' }}>
              <Grid container>
                <Grid item xs={12} sm={4} style={isSmallScreen ? { display: 'flex', justifyContent: 'center', marginBottom: '2rem' } : undefined}>
                  <img src={LogoSportConnection} alt="" style={{ width: '250px', height: '250px' }} />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <StrapiRichText source={content.blockSportConnection} sx={blockListSx} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginTop: '2rem' }}>
          <h1 style={{ fontFamily: 'Montserrat', fontWeight: '700' }}>{content.partnersTitle}</h1>
          <img src={hr} alt="" width="80" height="50" />
        </div>
        <Container maxWidth="md" style={{ marginTop: '3rem' }}>
          <StrapiRichText source={content.partnersBody} sx={partnersListSx} />
        </Container>
        <Footer />
      </Fade>
    </div>
  );
};

export default NosActions;
